import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';

import {
  getAlertsAndHitsChartFail,
  getAlertsAndHitsChartSuccess,
  getBusinessSegmentsParametersDataFail,
  getBusinessSegmentsParametersDataSuccess,
  getCustomerViewDataFail,
  getCustomerViewDataSuccess,
  getFigureDataFail,
  getFigureDataSuccess,
  getHitsDistributionChartFail,
  getHitsDistributionChartSuccess,
  getSegmentsFail,
  getSegmentsSuccess,
  NS_GET_ALERTS_HITS_CHART,
  NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA,
  NS_GET_CUSTOMER_VIEW_DATA,
  NS_GET_FIGURE_DATA,
  NS_GET_HITS_DISTRIBUTION_CHART,
  NS_GET_SEGMENTS
} from '../../redux/actions/ns/dashboard';

import {
  getAlertsAndHitsChart,
  getBusinessSegmentsParametersData,
  getCustomerViewData,
  getFigureData,
  getHitsDistributionChart,
  getSegments
} from '../../services/ns/dashboard';

// Figure Data

function* getFigureDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getFigureData, payload);
    yield put(getFigureDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getFigureDataFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchFigureData() {
  yield takeEvery(NS_GET_FIGURE_DATA, function* ({ payload }) {
    yield fork(getFigureDataWorker, payload);
  });
}

// Alerts and Hits Chart

function* getAlertsAndHitsDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getAlertsAndHitsChart, payload);
    yield put(getAlertsAndHitsChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getAlertsAndHitsChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetAlertsAndHits() {
  yield takeEvery(NS_GET_ALERTS_HITS_CHART, function* ({ payload }) {
    yield fork(getAlertsAndHitsDataWorker, payload);
  });
}

// Hits Distribution Chart

function* getHitsDistributionDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getHitsDistributionChart, payload);
    yield put(getHitsDistributionChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getHitsDistributionChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetHitsDistribution() {
  yield takeEvery(NS_GET_HITS_DISTRIBUTION_CHART, function* ({ payload }) {
    yield fork(getHitsDistributionDataWorker, payload);
  });
}

// Segments

function* getSegmentsDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getSegments, payload);
    yield put(getSegmentsSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getSegmentsFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetSegments() {
  yield takeEvery(NS_GET_SEGMENTS, function* ({ payload }) {
    yield fork(getSegmentsDataWorker, payload);
  });
}

// Business Segments and Parameters data

function* getBusinessSegmentsAndParametersData(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getBusinessSegmentsParametersData, payload);
    yield put(getBusinessSegmentsParametersDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(
      getBusinessSegmentsParametersDataFail({ error: 'Please try again' })
    );
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetSegmentsAndParameters() {
  yield takeEvery(
    NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA,
    function* ({ payload }) {
      yield fork(getBusinessSegmentsAndParametersData, payload);
    }
  );
}

// Customer View data

function* getCustomerViewChartData(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getCustomerViewData, payload);
    yield put(getCustomerViewDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getCustomerViewDataFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchCustomerView() {
  yield takeEvery(NS_GET_CUSTOMER_VIEW_DATA, function* ({ payload }) {
    yield fork(getCustomerViewChartData, payload);
  });
}
